module.exports = __webpack_public_path__ + "img/41.3a5cc880.jpg";